import React from "react";
import { Container, Row, Col, Badge, Card, CardHeader, CardBody } from "shards-react";
import SmallStats from '../components/common/SmallStats'

import PageTitle from "../components/common/PageTitle";

class CountryWiseCoronaCases extends React.Component {
  constructor (props) {
    super(props);
    this.state = {
      allCoronaCases: {
          confirmed: "",
          active: "",
          deaths: "",
          recovered: ""
      },
      countryWiseCoronaCases: [],
      data: [
        {
          label: "Today",
          fill: "start",
          borderWidth: 1.5,
          backgroundColor: "rgba(0, 184, 216, 0.1)",
          borderColor: "rgb(0, 184, 216)",
          data: []
        }
      ]
    }
  }

  componentDidMount() {
    fetch("https://corona.lmao.ninja/v2/all")
    .then((res) => res.json())
    .then((data) => {
      this.setState({
        allCoronaCases: {
            confirmed: data.cases,
            recovered: data.recovered,
            active:data.active,
            deaths: data.deaths
        }
      });
    })
    .catch(console.log);

    fetch("https://corona.lmao.ninja/v2/countries?sort=cases")
    .then((res) => res.json())
    .then((data) => {
      this.setState({
        countryWiseCoronaCases: data
      });
    })
    .catch(console.log);
  }

  render() {
    return (
    <Container fluid className="main-content-container px-4">
    {/* Page Header */}
    <Row noGutters className="page-header py-4">
      <PageTitle sm="4" title="Country Wise Report" subtitle="Global COVID-19 Stats" className="text-sm-left" />
    </Row>

    {/* Default Light Table */}
    <Row>
        <Col className="col-lg mb-4">
          <SmallStats
            variation="1"
            chartData = {this.state.data}
            label={'Confirmed'}
            value={this.state.allCoronaCases.confirmed}
          />
        </Col>
        <Col className="col-lg mb-4">
          <SmallStats
            variation="1"
            chartData = {this.state.data}
            label={'Active'}
            value={this.state.allCoronaCases.active}
          />
        </Col>
        <Col className="col-lg mb-4">
          <SmallStats
            variation="1"
            chartData = {this.state.data}
            label={'Recovered'}
            value={this.state.allCoronaCases.recovered}
          />
        </Col>
        <Col className="col-lg mb-4">
          <SmallStats
            variation="1"
            chartData = {this.state.data}
            label={'Deaths'}
            value={this.state.allCoronaCases.deaths}
          />
        </Col>
    </Row>
    <Row>
        
      <Col>
        <Card small className="mb-4">
          <CardHeader className="border-bottom">
            <h6 className="m-0">Reported corona cases so far...</h6>
          </CardHeader>
          <CardBody className="p-0 pb-3">
            <table className="table mb-0">
              <thead className="bg-light">
                <tr>
                  <th scope="col" className="border-0">
                    Country
                  </th>
                  <th scope="col" className="border-0">
                    Confirmed
                  </th>
                  <th scope="col" className="border-0">
                    Active
                  </th>
                  <th scope="col" className="border-0">
                    Critical
                  </th>
                  <th scope="col" className="border-0">
                    Recovered
                  </th>
                  <th scope="col" className="border-0">
                    Deaths
                  </th>
                </tr>
              </thead>
              <tbody>
                
                {this.state.countryWiseCoronaCases.map((data, index) => {
                    return (
                      <tr key={index}>
                        <td>{data.country}  </td>
                    <td>{data.cases}{" "}{data.todayCases == 0 ? '' :<Badge theme="light" className="deltaconfirmed"><span className="text-primary text-bold">+{data.todayCases}</span></Badge>}</td>
                        <td>{data.active}</td>
                        <td>{data.critical}</td>
                        <td>{data.recovered}</td>
                        <td>{data.deaths}{data.todayDeaths == 0 ? '' :<Badge theme="light" className="deltaconfirmed"><span className="text-danger text-bold">+{data.todayDeaths}</span></Badge>}</td>
                      </tr>
                    )
                })}
              </tbody>
            </table>
          </CardBody>
        </Card>
      </Col>
    </Row>

  </Container>
    );
  }
}
 

export default CountryWiseCoronaCases;
